import { StringIndexedDict } from "../../../../api/GenericTypes";
import {
  GenericEntityVirtualizedEntitySelectFormFieldProps,
  GenericVirtualizedEntitySelectFormFieldControllerWrapper,
} from "../../../formfields/GenericVirtualizedSelectFormField/GenericVirtualizedEntitySelectFormFieldControllerWrapper";
import { useContext } from "react";
import { SessionContext } from "../../../contexts/SessionContext";
import { useEntityCount } from "../../../../api/BaseEntityApi";
import { LoadingWrapper } from "../../../LoadingWrapper";
import { CustomTypeSuggestions } from "../../../../api/CustomTypes/CustomTypesBase";
import {
  customTypeTemplateConstants,
  CustomTypeTemplateFilters,
  CustomTypeTemplateSortingOptionsConsts,
} from "../../../../api/CustomTypes/CustomTypeTemplates";

export const CustomTypeTemplatesVirtualizedSelectForm = <Entity extends StringIndexedDict>(
  props: GenericEntityVirtualizedEntitySelectFormFieldProps<
    Entity,
    CustomTypeSuggestions,
    CustomTypeTemplateFilters
  > & {
    enableBasicOption?: boolean;
    hideIfNoTypes?: boolean;
  }
) => {
  const { session } = useContext(SessionContext);

  const {
    data: countQuery,
    status,
    fetchStatus,
  } = useEntityCount(customTypeTemplateConstants.resource, props.filters, {
    enabled: !!props.hideIfNoTypes,
  });
  return (
    <LoadingWrapper status={status} fetchStatus={fetchStatus}>
      {props.hideIfNoTypes && countQuery?.count === 0 ? (
        <></>
      ) : (
        <GenericVirtualizedEntitySelectFormFieldControllerWrapper<
          Entity,
          CustomTypeSuggestions,
          CustomTypeTemplateFilters
        >
          {...props}
          filters={{ sortBy: [{ property: "NAME", sortDirection: "ASC" }], ...props.filters }}
          entityConstants={customTypeTemplateConstants}
          orderByOptions={CustomTypeTemplateSortingOptionsConsts}
          allowCreateEntity={session?.permissions.administer_custom_field_schemas && props.allowCreateEntity}
          concatItems={
            props.enableBasicOption && !props.allowUnassigned && props.filters?.entityTypes?.length === 1
              ? [{ id: 0, name: `Basic ${props.filters.entityTypes[0]}` }]
              : props.concatItems
          }
        />
      )}
    </LoadingWrapper>
  );
};
